import { UssdSessionCloseReasonQuery } from '../api/interfaces';
import { nortadaLogger } from '../components/common/logger';

const ussdSessionCloseReasonQueryMapper = (reason: string): UssdSessionCloseReasonQuery => {
  const translations: Record<string, UssdSessionCloseReasonQuery> = {
    End: 'END',
    Abandon: 'ABANDON',
    Timeout: 'TIMEOUT',
    'Session in progress': 'NOT_CLOSED_YET'
  };

  return translations[reason] ?? nortadaLogger.critical(`${reason} is unsupported Ussd session close reason query.`);
};

export default ussdSessionCloseReasonQueryMapper;
